<InactivityModal />
<div class="container-fluid h-100">
  <div class="row h-100 ">
    <div class="col-auto bg-white h-100 d-none d-lg-block">
      <Sidebar ref="sidebar"></Sidebar>
    </div>
    <div class="col bg-white h-100 m-0">
      <Navbar @toggle-sidebar="toggleSidebar"></Navbar>
      <div class="bg-gray px-4 py-1 h-100 scroll-container">
        <div class="card bg-transparent mt-3 rounded-5 border-0">
          <div class="card-body">
            <!-- Move container-fluid up here to wrap BOTH label/button AND cards -->
            <div class="container-fluid">
          
              <!-- Label and Add Button -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="text-sm">Membership Management</label>
                <div class="d-flex gap-2">
                  <button class="btn btn-sm btn-primary text-xxs rounded-3 shadow-sm" data-bs-toggle="modal"
                    data-bs-target="#create_membership">+ Add Membership</button>
                </div>
              </div>
          
              <!-- Tab content -->
              <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade active show" id="pills-subscriptions" role="tabpanel"
                  aria-labelledby="pills-subscriptions-tab">
          
                  <!-- Cards row -->
                  <div class="row mt-4">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-4" v-for="(membership, index) in memberships" :key="membership.id">
                      <div class="card h-100 shadow-sm border-0 card-smooth">
                        <div class="card-body d-flex flex-column justify-content-between">
                          <!-- Top section -->
                          <div class="d-flex justify-content-between align-items-start">
                            <div class="d-flex align-items-center gap-2">
                              <div>
                                <h5 class="fw-bold mb-2">{{ membership.name }}</h5>
                                <small class="text-muted text-xxs">{{ membership.description }}</small>
                              </div>
                            </div>
                            <div class="d-flex gap-2">
                              <!-- Edit Button -->
                              <button
                                class="btn btn-sm btn-link p-0 text-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#update_membership"
                                @click.prevent="editMembership(membership)"
                                title="Edit membership"
                                aria-label="Edit membership"
                              >
                                <i class="bi bi-pencil"></i>
                              </button>
          
                              <!-- Delete Button -->
                              <button
                                class="btn btn-sm btn-link p-0 text-danger fw-bold"
                                @click="delete_membership(membership.id)"
                                title="Delete membership"
                                aria-label="Delete membership"
                              >
                                <i class="bi bi-trash text-danger"></i>
                              </button>
                            </div>
                          </div>
          
                          <!-- Grouped Info -->
                          <div class="membership-info mt-2 mb-3 d-flex flex-column gap-2">
                            <!-- Price -->
                            <div>
                              <h4 class="fw-bold text-primary mb-0">
                                {{
                                  (membership.membership_pricing || []).length > 0
                                    ? 'R ' + Number(membership.membership_pricing[0].price).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                    : 'N/A'
                                }}
                                <small class="text-muted text-xxs">/{{ membership.billing_cycle?.name || '' }}</small>
                              </h4>
                            </div>
          
                            <!-- Subscribers -->
                            <div class="d-flex align-items-center justify-content-between bg-light p-2 rounded">
                              <div class="text-muted small">
                                <i class="bi bi-people me-1"></i> Subscribers
                              </div>
                              <span class="badge bg-primary text-white px-2 py-1">{{ total_paid_users[membership.id] || 0 }}</span>
                            </div>
          
                            <!-- Perks & Benefits -->
                            <div>
                              <div class="fw-bold text-muted small mb-1">
                                <i class="bi bi-stars me-1 text-primary"></i> Perks & Benefits
                              </div>
                              <div class="perk-list-scroll">
                                <ul class="list-unstyled mb-0">
                                  <li
                                    v-if="membership.membership_perks && membership.membership_perks.length"
                                    v-for="perk in membership.membership_perks"
                                    :key="perk.id"
                                    class="mb-1 text-xxs"
                                  >
                                    <i class="bi bi-check-circle-fill me-1"></i>
                                    {{ perk.perk.name }}
                                  </li>
                                  <li v-else class="text-muted text-xxs fst-italic align-items-center text-center mt-2">No perks added</li>
                                </ul>
                              </div>
                            </div>
                          </div>
          
                          <!-- Action Buttons -->
                          <div class="d-flex justify-content-center gap-2">
                            <button
                              class="btn btn-sm btn-outline-secondary rounded-pill px-2 text-xxs"
                              data-bs-toggle="modal"
                              data-bs-target="#manage_perks_modal"
                              @click="open_manage_perks_modal(membership.id)">
                              Manage Perks
                            </button>
                            <button
                              class="btn btn-sm btn-primary rounded-pill px-2 text-xxs"
                              @click="$router.push('view_membership_users/' + membership.id)"
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End cards row -->

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal for Creating Membership -->
      <div class="modal fade" id="create_membership" tabindex="-1" aria-labelledby="createMembershipLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <p class="modal-title text-xs fw-500">Create Membership</p>
              <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <form @submit.prevent="createMembership">
              <div class="modal-body">
                <div class="mb-3">
                  <label for="membership_name" class="form-label text-xs fw-500">
                    Membership Name <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control rounded-5 text-xs" id="membership_name"
                    v-model="membership_name" placeholder="Enter membership name">
                  <p v-if="errors.membership_name" class="text-danger text-xs">{{ errors.membership_name
                    }}</p>
                </div>

                <div class="mb-3">
                  <label for="membership_description" class="form-label text-xs fw-500">Description</label>
                  <textarea class="form-control rounded-5 text-xs" id="membership_description"
                    v-model="membership_description" placeholder="Enter description"></textarea>
                </div>

                <!-- Membership Type -->
                <div class="mb-3">
                  <label for="membership_type" class="form-label text-xs fw-500">
                    Membership Type <span class="text-danger">*</span>
                  </label>

                  <!-- Dropdown for existing types -->
                  <select class="form-select rounded-5 text-xs mb-2" id="membership_type" v-model="membership_type">
                    <option selected hidden value="">Select membership type</option>
                    <option v-for="type in membership_types" :key="type.id" :value="type.id">
                      {{ type.name }}
                    </option>
                  </select>

                  <!-- "or" text -->
                  <div class="text-center text-muted text-xs">or</div>

                  <!-- Input for custom type -->
                  <input type="text" class="form-control rounded-5 text-xs mt-2"
                    placeholder="Enter custom membership type" v-model="custom_membership_type"/>

                  <!-- Error display -->
                  <p v-if="errors.membership_type" class="text-danger text-xs">
                    {{ errors.membership_type }}
                  </p>
                </div>


                <!-- Membership Pricing -->
                <div class="mb-3">
                  <label for="membership_price" class="form-label text-xs fw-500">
                    Membership Price <span class="text-danger">*</span>
                  </label>
                  <input type="number" class="form-control rounded-5 text-xs" id="membership_price"
                    v-model="membership_price" placeholder="Enter price" min="0">
                  <p v-if="errors.membership_price" class="text-danger text-xs">{{ errors.membership_price
                    }}</p>
                </div>

                <!-- Biliiling cycle -->
                <div class="mb-3">
                  <label for="billing_cycle" class="form-label text-xs fw-500">
                    Billing type choices <span class="text-danger">*</span>
                  </label>
                  <select class="form-select rounded-5 text-xs" id="billing_cycle" v-model="billing_cycle">
                    <option selected hidden>Select membership type</option>
                    <option v-for="billing_cycle in billing_cycle_choices" :key="billing_cycle.id"
                      :value="billing_cycle.id">
                      {{ billing_cycle.name }}
                    </option>
                  </select>
                  <p v-if="errors.billing_cycle" class="text-danger text-xs">{{ errors.billing_cycle
                    }}</p>
                </div>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn btn-primary text-xs rounded-5">Create Membership</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="modal fade" id="manage_perks_modal" tabindex="-1" aria-labelledby="manage_perks_modal"
        style="display: none;" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered ">
          <div class="modal-content rounded-5">
            <div class="modal-header">
              <h6 class="modal-title">Manage Perks</h6>
              <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div class="modal-body">

              <div v-if="membership_perks.length > 0">
                <button class="btn btn-primary btn-sm" type="button" @click="add_perk_input">
  <i class="bi bi-plus-circle"></i> Add Perk
</button>
                <div v-for="(perk, index) in membership_perks" :key="index" class="mb-3">

                  <label class="form-label text-xxs">Perk Name:</label>
                  <div class="input-group">
                    <select class="form-select rounded-3 shadow-sm text-xxs" v-model="perk.id">
                      <option value="" selected>-- Select existing perk --</option>
                      <option
  v-for="existing in available_perks"
  :key="existing.id"
  :value="existing.id"
  :disabled="membership_perks.some(p => p.id === existing.id)">
  {{ existing.name }}
</option>
                    </select>
                    <!-- Remove button -->
                    <button class="btn btn-danger" type="button" @click="remove_perk(index)"
                      v-if="membership_perks.length > 1">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>

              </div>

              <div v-else>
                <p>No perks available. Please add some perks.</p>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-primary btn-sm text-xs" @click="save_perks_function">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>


      <div class="modal fade" id="update_membership" tabindex="-1" aria-labelledby="updateMembershipLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xs fw-500">Update Membership</p>
          <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>

        <form @submit.prevent="updateMembership">
          <div class="modal-body">
            <!-- Membership Name -->
            <div class="mb-3">
              <label class="form-label text-xs fw-500">
                Membership Name <span class="text-danger">*</span>
              </label>
              <input type="text" class="form-control rounded-5 text-xs"
                v-model="editMembershipData.name" placeholder="Enter membership name">
            </div>

            <!-- Description -->
            <div class="mb-3">
              <label for="membership_description" class="form-label text-xs fw-500">Description</label>
              <textarea class="form-control rounded-5 text-xs" id="membership_description"
                v-model="editMembershipData.description" placeholder="Enter description"></textarea>
            </div>

            <!-- Membership Type -->
            <div class="mb-3">
              <label for="membership_type" class="form-label text-xs fw-500">
                Membership Type <span class="text-danger">*</span>
              </label>

              <select class="form-select rounded-5 text-xs mb-2" id="membership_type"
                v-model="editMembershipData.type_id" :disabled="editMembershipData.custom_type !== ''">
                <option selected hidden value="">Select membership type</option>
                <option v-for="type in membership_types" :key="type.id" :value="type.id">
                  {{ type.name }}
                </option>
              </select>

              <div class="text-center text-muted text-xs">or</div>

              <input type="text" class="form-control rounded-5 text-xs mt-2"
                placeholder="Enter custom membership type" v-model="editMembershipData.custom_type"
                :disabled="editMembershipData.type_id !== ''" />

              <p v-if="errors.membership_type" class="text-danger text-xs">{{ errors.membership_type }}</p>
            </div>

            <!-- Price -->
            <div class="mb-3">
              <label for="membership_price" class="form-label text-xs fw-500">
                Membership Price <span class="text-danger">*</span>
              </label>
              <input type="number" class="form-control rounded-5 text-xs" id="membership_price"
                v-model="editMembershipData.price" placeholder="Enter price" min="0">
              <p v-if="errors.membership_price" class="text-danger text-xs">{{ errors.membership_price }}</p>
            </div>

            <!-- Billing Cycle -->
            <div class="mb-3">
              <label for="billing_cycle" class="form-label text-xs fw-500">
                Billing Cycle <span class="text-danger">*</span>
              </label>
              <select class="form-select rounded-5 text-xs" id="billing_cycle"
                v-model="editMembershipData.billing_cycle_id">
                <option selected hidden>Select billing cycle</option>
                <option v-for="cycle in billing_cycle_choices" :key="cycle.id" :value="cycle.id">
                  {{ cycle.name }}
                </option>
              </select>
              <p v-if="errors.billing_cycle" class="text-danger text-xs">{{ errors.billing_cycle }}</p>
            </div>
          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xs rounded-5">Update Membership</button>
          </div>
        </form>
      </div>
    </div>
  </div>



    </div>
  </div>
</div>